export default __webpack_public_path__ + "static/media/LinkedIN_white.03a188e3.svg";